export class Report {
    supplierAB ! :number;
    objectAccount!: string;
    area?: string | null;
    department?: string | null;
    year!: string;
    cmd!: string;
    Month!: string;
    Drop!: number;
    FromDate?: string | null;
    ToDate?: string | null;
    ApprDate?: string | null;
    CAI!: string;
    ProvisionalId !: string;
    Contractid!:string;
    FromAppDate?: string | null;
    ToAppDate?: string | null;
}
